import styled from '@emotion/styled';
import React, { FC } from 'react';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import { useI18n } from '~Hooks';
import { Box } from '~Styles';

const DividerWrapper = styled(Box)<{ maxWidth?: string }>`
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth ?? '100%'};
  color: var(--colorBlueGray800);
`;

const DividerLine = styled.div<{ margin?: string }>`
  flex: 1;
  height: 1px;
  background-color: var(--colorBlueGray800);
  margin: ${({ margin }) => margin ?? 'auto'};
`;

interface Props {
  text?: string;
  maxWidth?: string;
}

/** Reusable divider that can be used in between multiple choices */
const DividerWithText: FC<Props> = ({ text, maxWidth }) => {
  const { i18n } = useI18n();

  return (
    <DividerWrapper display="flex" alignItems="center" maxWidth={maxWidth}>
      <DividerLine margin="0 16px 0 0" />
      <Paragraph level={4} color="var(--colorWhite)" style={{ flexShrink: 0 }}>
        {text ?? i18n('General.Or')}
      </Paragraph>
      <DividerLine margin="0 0 0 16px" />
    </DividerWrapper>
  );
};

export default DividerWithText;
